import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makePropTypesFactory, makeValidatingTransformFactory } from "./factory";
export var makePropTypes = makePropTypesFactory(function (vars) {
  return {
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltipActive: PropTypes.bool,
    tooltipColor: PropTypes.oneOf(vars.colors),
    tooltipMultiline: PropTypes.bool,
    tooltipPosition: PropTypes.oneOf(vars.tooltipPositions),
    tooltipResponsive: PropTypes.objectOf(PropTypes.oneOf(vars.tooltipPositions))
  };
});
export var transform = function transform(props) {
  var _ref;

  var className = props.className,
      tooltip = props.tooltip,
      tooltipActive = props.tooltipActive,
      tooltipColor = props.tooltipColor,
      tooltipMultiline = props.tooltipMultiline,
      tooltipPosition = props.tooltipPosition,
      _props$tooltipRespons = props.tooltipResponsive,
      tooltipResponsive = _props$tooltipRespons === void 0 ? {} : _props$tooltipRespons,
      rest = tslib_1.__rest(props, ["className", "tooltip", "tooltipActive", "tooltipColor", "tooltipMultiline", "tooltipPosition", "tooltipResponsive"]);

  return Object.assign({
    className: classNames.apply(void 0, [(_ref = {
      "is-tooltip-active": tooltipActive
    }, _defineProperty(_ref, "is-tooltip-".concat(tooltipColor), tooltipColor), _defineProperty(_ref, "is-tooltip-multiline", tooltipMultiline), _defineProperty(_ref, "is-tooltip-".concat(tooltipPosition), tooltipPosition), _defineProperty(_ref, "tooltip", tooltip), _ref)].concat(_toConsumableArray(Object.keys(tooltipResponsive).map(function (breakpoint) {
      return "is-tooltip-".concat(tooltipResponsive[breakpoint], "-").concat(breakpoint);
    })), [className]))
  }, tooltip !== undefined ? {
    "data-tooltip": tooltip
  } : {}, rest);
};
export var makeValidatingTransform = makeValidatingTransformFactory(makePropTypes, transform);